import loadable from "@loadable/component";
export default loadable(function() {
    return import("./header");
});
